import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import QrCheckinScannerDialog from 'src/common/components/QrCheckinScannerDialog';
import { WizardFindOption } from 'src/helpers/userCheckinWizard';
import { IEnrichedParticipant } from 'src/interfaces/Participant';
import { IUser } from 'src/interfaces/User';

import WizardFindAutocomplete from '../WizardFindAutocomplete';

interface Props {
  users: IUser[];
  unownedParticipants: IEnrichedParticipant[];
  selectedOption: WizardFindOption | null;
  onSelectOption: (option: WizardFindOption | null) => void;
  qrScannerOpen: boolean;
  onOpenQrScanner: () => void;
  onCloseQrScanner: () => void;
  onQrScan: (raw: string) => void | Promise<void>;
}

export default function FindUserStep({
  users,
  unownedParticipants,
  selectedOption,
  onSelectOption,
  qrScannerOpen,
  onOpenQrScanner,
  onCloseQrScanner,
  onQrScan,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <WizardFindAutocomplete
            users={users}
            unownedParticipants={unownedParticipants}
            value={selectedOption}
            onChange={onSelectOption}
          />
        </Box>
        <Button
          sx={{ flexShrink: 0, height: 40 }}
          size="small"
          variant="outlined"
          startIcon={<QrCodeScannerIcon />}
          onClick={onOpenQrScanner}
        >
          {t('checkins.scanQr')}
        </Button>
      </Box>
      <QrCheckinScannerDialog open={qrScannerOpen} onClose={onCloseQrScanner} onScan={onQrScan} />
    </Box>
  );
}
